export const baseURL =
  process.env.REACT_APP_API_URL || "https://api.mausool.com";
console.log("🚀 ~ baseURL:", baseURL);

const baseConfig = {
  baseURL: `${baseURL}`,
  timeout: 30000,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
};

export default baseConfig;
